module.exports = __webpack_public_path__ + "img/img7.632d1465.png";